import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const UserProfileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 32px;
`;

export const SectionHeading = styled.div`
  margin-bottom: 24px;
`;

export const ContentRow = styled.div`
  display: flex;
  gap: 24px;
`;
